import { render } from "./structuresBrowser.vue?vue&type=template&id=53b877b7"
import script from "./structuresBrowser.vue?vue&type=script&lang=js"
export * from "./structuresBrowser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__